var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenAndPaperIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.572 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pen_and_paper_icon_svg__a,.pen_and_paper_icon_svg__b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.pen_and_paper_icon_svg__b{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pen_and_paper_icon_svg__a",
    d: "M49.823 16.035H1.006M5.098 11.615H7.45M9.794 11.615h2.352M14.49 11.615h2.352M79.572 8.128L52.233 35.467l-8.031.9.91-8.031L72.444 1zM68.563 4.888l6.349 6.349M8.061 23.082h25.657v14.35H8.061zM8.061 43.337H20.89M8.061 54.76h26.523M28.003 43.337h10.39M8.061 49.052h39.061"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pen_and_paper_icon_svg__b",
    d: "M66.161 27.451V58.03a2.847 2.847 0 01-2.694 2.971H3.7a2.847 2.847 0 01-2.693-2.942V10.087A2.847 2.847 0 013.7 7.116h59.767a2.577 2.577 0 011.908.874"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenAndPaperIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen_and_paper_icon.80d670376519696fa83db73e9c8ef001.svg";